<template>
  <div class="placement">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon >
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-a-PaidPlacement" style="color: #fff;"></use>
      </svg>
    </breadcrumbs>
    <artmisads-select-button class="apply-btn" type="primary" @click.stop="apply">{{ st('placement.apply') }}</artmisads-select-button>

    <a-spin :spinning="loading">
    <div class="content-top">
      <div class="content-top-title">
        {{ st('placement.sectionPublisherInfo') }}
      </div>
      <div class="content-top-content">
       <publisherTable :dataSource="publisherData" :hasAvailablePrograms="false" ref="publisherTableRef"/>
      </div>

    </div>
    <div class="content-bottom">
      <div class="content-bottom-left">
        <div class="content-top-title">
          {{ st('placement.sectionPlacementInfo') }}
        </div>
        <div class="content-bottom-content">
          <div class="item">
            <div class="title">
              {{ st('placement.labelPlacementName') }}
            </div>
            <div class="content text-one">
              {{ placementInfo.name }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              {{ st('placement.labelDuration') }}
            </div>
            <div class="content">
              {{ placementInfo.durationDays != null ? st('placement.durationDays', { n: placementInfo.durationDays }) : '-' }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              {{ st('placement.labelPrice') }}
            </div>
            <div class="content red-text">
              {{ CURRENCY_DATA_MAPPER[placementInfo.currency] }} {{ placementInfo.price?.toFixed(2) }}
            </div>
          </div>
        </div>
        <div class="content-bottom-content">
          <div class="item">
            <div class="title">
              {{ st('placement.labelAvailableFrom') }}
            </div>
            <div class="content">
              {{ placementInfo.availableFrom ? setTime(placementInfo.availableFrom, false) : '-' }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              {{ st('placement.labelLeadTime') }}
            </div>
            <div class="content">
              {{ placementInfo.leadTimeDays != null ? st('placement.durationDays', { n: placementInfo.leadTimeDays }) : '-' }}
            </div>
          </div>
          <div class="item">

          </div>
        </div>
        <div class="content-bottom-description">
          <div class="item">
            <div class="title">
              {{ st('placement.labelPlacementDescription') }}
            </div>
            <div class="contentDescription">
              {{ placementInfo.description }}
            </div>
          </div>
        </div>
        <div class="content-bottom-description">
          <div class="item">
            <div class="title">
              {{ st('placement.labelSpecs') }}
            </div>
            <div class="contentDescription">
              {{ placementInfo.specifications }}
            </div>
          </div>
        </div>
      </div>
      <div class="content-bottom-right">
        <div class="content-top-title">
          {{ st('placement.sectionAdvancedInfo') }}
        </div>
        <div class="content-bottom-content">
          <div class="item">
            <div class="title">
              {{ st('placement.labelAutoCancelPeriod') }}
            </div>
            <div class="content">
              {{ placementInfo.autoCancelPeriodDays != null ? st('placement.durationDays', { n: placementInfo.autoCancelPeriodDays }) : '-' }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              {{ st('placement.labelAvailableLinkType') }}
            </div>
            <div class="content-linkType">
              <img v-if="placementInfo.linkType === 'attribution'" src="../../../../assets/images/img/AT@2x.png" alt=""
                class="icon">
              <img v-else src="../../../../assets/images/img/AS@2x.png" alt="" class="icon">
              <span class="content-linkType-text">{{ placementInfo.linkType === 'attribution' ? 'Attribution' :
                'Associate' }}</span>
            </div>
          </div>
        </div>
        <div class="content-bottom-content">
          <div class="item">
            <div class="title">
              {{ st('placement.labelMaxPromotableAsins') }}
            </div>
            <div class="content">
              {{ placementInfo.maxAsinCount }}
            </div>
          </div>
          <div class="item">
            <div class="title">
              {{ st('placement.labelAvailableResultsDisplay') }}
            </div>
            <div class="content">
              {{ setAvailableResultTypes(placementInfo.availableResultTypes) }}
            </div>
          </div>
        </div>
        <div class="content-bottom-content">
          <div class="item">
            <div class="title">
              {{ st('placement.labelExamples') }}
            </div>
            <div class="item-content">
              <div v-for="item in placementInfo.exampleFiles" :key="item.id">
                <div v-if="isImage(item.originalFileName)" class="item-content-image">
                  <a-image :src="item.url" alt="" :placeholder="true" />
                </div>
                <div v-else>
                  {{ item.originalFileName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </a-spin>
    <ApplicationModel ref="applicationModelRef" @refresh="refresh"/>
    <a-modal v-model:open="open" title="" :footer="null" :mask="false" :maskClosable="false" width="700px">
        <div>
        <div class="success-text-box">
          <svg-icon name="success-tianchong" style="width: 24px;height: 24px;color: #80C026;font-size: 24px;"/>
          <p class="success-text">{{ st('placement.successTitle') }}</p>
        </div>
        <p class="success-text mg-16 ml-24">{{ st('placement.successBodyBefore') }}<span class="font-bolder">{{ st('placement.successBodyPath') }}</span></p> 
        <div style="margin-left: 34px;margin-top: 10px;">
          <artmisads-select-button type="primary" @click="goToCampaigns">{{ st('placement.goToCampaigns') }}</artmisads-select-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import breadcrumbs from '@/components/breadcrumbs.vue'
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { CURRENCY_DATA_MAPPER } from '~/contants/common'
import LogoImage from '@/components/LogoImage.vue'
import { sellerPlacementApi } from '~/server/index'
import ApplicationModel from './applicationModel.vue'
import { useRouter } from 'vue-router'
import SvgIcon from '~/components/SvgIcon.vue';
import publisherTable from './components/publisherTable.vue'
import { setTime } from '~/utils'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()

const applicationModelRef = ref(null)
const publisherData=ref([])
const route = useRoute()
const placementId = ref(route.params.id)
const placementInfo = ref({})
const loading = ref(false)
const open=ref(false)
const router = useRouter()
const breadcrumbsData = computed(() => ({
  title: st('placement.pageDetailTitle'),
  des: st('placement.pageDetailDes'),
  color: '#80C026',
  links: [
    {
      name: st('common.home'),
      path: "/seller/dashboard",
    },
    {
      name: st('placement.breadcrumbPaidPlacements'),
      path: "/seller/Settings/paidPlacement/placement",
    },
    {
      name: st('placement.pageDetailTitle'),
      path: `/seller/Settings/paidPlacement/placement/${route.params.id}`,
    },
  ],
}))
const getComputedData = (item) => computed(() => {

if (Array.isArray(item)) {
  if (item.length > 0) {
    return item.map(item => item.name).join(',')
  }
  else {
    return '--'
  }
}
else {
  return '--'
}
})
const goToCampaigns=()=>{
  router.push('/seller/Settings/paidPlacement/campaigns')
}

const isImage = (url) => {
  if (!url) return
  return url.includes('.jpg') ||url.includes('.JPG') || url.includes('.jpeg') ||url.includes('.JPEG') || url.includes('.png') || url.includes('.gif')||url.includes('.PNG')||url.includes('.GIF')
}
const apply = () => {
  applicationModelRef.value.handleOpen(placementId.value,placementInfo.value.maxAsinCount)
}
const refresh=()=>{
  open.value = true
 
}
onMounted(() => {
  loading.value = true
  placementId.value = route.params.id
  sellerPlacementApi.getPlacementById(placementId.value).then(res => {
    placementInfo.value = res.data
    publisherData.value = [res.data.publisher]
  
  }).finally(() => {
    loading.value = false
  })
})
const setAvailableResultTypes = (availableResultTypes) => {
  if (Array.isArray(availableResultTypes)) {
    return availableResultTypes.join("/")
  }
}
</script>

<style scoped lang="less">
.success-text-box{
  display: flex;
  align-items: center;
  gap: 10px;
}
.ml-24{
  margin-left: 34px !important;
}
.mg-16{
  margin: 5px 0;
}
.success-text{
  color: #0f0629;
      font-family: "Sora";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
      width: 660px;
      
}
.link-text{
   text-decoration: underline;
}
.font-bolder{
  font-weight: 600;
}
.text-one{
  display: block;
}
/* 覆盖 .item-content 上的 display:flex，确保省略号生效 */
.item-content.text-one{
  display: block !important;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 允许弹性子项在 flex 布局中收缩，否则省略号不会生效 */
.content-wrapper-bottom-top .item{
  min-width: 0;
}
.apply-btn{
  position: absolute;
  right: 16px;
  top: 50px;
  width: 100px;
  z-index: 10
}
.placement {
  padding: 16px;
  padding-top: unset;
  position: relative;
  width: 100%;
  .program-status {
  .info-item {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  // .item:not(:first-child):not(:last-child) {
  //   margin: 0 5px;
  // }
  .icon-app{
    font-size: 20px;
      border-radius: 4px;
      overflow: hidden;
      background-color: var(--bg-gray-5);
  }
  .icon-app-default {
      font-size: 16px;
      padding: 2px;
      border-radius: 4px;
      overflow: hidden;
      background-color: var(--bg-gray-5);
      color: var(--dark-4);
    }
  .item {
    display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    // background: #F1F0F5;

    .icon {
      width: 20px !important;
      height: 20px !important;
    }

    .item-text {
      color: #0f0629;
      font-family: "Sora";
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
    }
  }
}
  .content-linkType {
    display: inline-flex;
    width: fit-content;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #F1F0F5;
  
    .content-linkType-text {
      font-family: Sora;
      font-weight: 400;
      font-size: 13px;

      letter-spacing: 0.3px;

    }

    .icon {
      width: 20px !important;
      height: 20px !important;
    }
  }

  .content-top-title {
    font-family: Sora;
    font-weight: 600;
    font-size: 20px;
    padding: 16px;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #E5E5E5;
  }

  .content-top {
    background-color: #fff;

    border-radius: 8px;



    .content-top-content {
      padding: 16px;
      display: flex;
      align-items: center;
      gap: 16px;
      flex: 1;
      .content-top-content-left{
        border-radius: 13.5px;
        overflow: hidden;
        width: 136px;
        height: 136px;
      
      }
      .content-top-content-right{
        flex: 1;
        display: flex;
        .item{
          flex: 1;
        }
      }
    }
  }
.content-bio{
  font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 14px;

line-height: 20px;
letter-spacing: 0.4px;

}
  .content-bottom-description {
    display: flex;
    align-items: center;
    padding: 10px 16px 10px 16px;

    flex: 1;
  }

  .item {
    flex-direction: column;
    display: flex;
    flex: 1;

  }

  .title {
    font-family: Sora;
    font-weight: 400;
    font-size: 13px;
    color: #0F0629;
    letter-spacing: 0.3px;

  }

  .item-content {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    .item-content-image {
      width: 100px;
      height: 100px;
      border-radius: 8px;
      border: 1px solid #E5E5E5;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #F1F0F5;
      :deep(img) {
        max-height: 100px;
         object-fit: contain;

      }
    }
  }

  .red-text {
    color: #EB4E3D;
  }

  .content {
    font-family: Sora;
    font-weight: 600;
    font-size: 14px;
    word-wrap: break-word;
    letter-spacing: 0.4px;

  }

  .content-bottom-content {
    display: flex;
    align-items: center;
    padding: 10px 16px 10px 16px;
    gap: 56px;
    flex: 1;


  }

  .contentDescription {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;



  }

  .content-bottom {
    margin-top: 16px;
    display: flex;
    flex: 1;
    gap: 16px;

    .content-bottom-left {
      flex: 1;
      border-radius: 8px;
      background-color: #fff;
    }

    .content-bottom-right {
      flex: 1;
      border-radius: 8px;
      background-color: #fff;
    }
  }
}
</style>